import { render } from "./ForumAvatar.vue?vue&type=template&id=3a0a65e7"
import script from "./ForumAvatar.vue?vue&type=script&lang=js"
export * from "./ForumAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__